<template>
  <div id="Start">
    <!-- <bg-video ref="bv" filename="Start-1" autoplay loop/> -->

    <img class="pos-c nav-text" src="./img/start-text.png" alt="nav-text">
    <guide-button class="btn-lt" @click.native="$router.push('/')">返回</guide-button>
    <guide-button class="btn-rt" @click.native="$router.push('/Experience')">继续</guide-button>
  </div>
</template>

<script>
export default {
  name: 'Start',
  mounted () {
    this.$narrate.play('01', { hideBtn: true })
  },
  beforeDestroy () {
    this.$narrate.clear()
  },
}
</script>

<style lang="scss" scoped>
#Start {
  background-image: url(./img/start-bg.jpg);
  background-size: cover;
}
.nav-text {
  display: inline-block;
  width: 16.3rem;
}
.btn-wrap {
  position: absolute;
  top: 8.8rem;
  left: 0;
  z-index: 111;
  width: 19.2rem;
  height: 1rem;
  text-align: center;
  .btn {
    display: inline-block;
    width: 2.75rem;
    height: 1rem;
    margin: 0 0.8rem;
    text-indent: -99999px;
    cursor: pointer;
  }
}
</style>
